import React from "react";
import { connect } from "react-redux";
import KIT from "../../Descargable/Kit de Apoyo E3.zip";
import { dataLayerTag } from "../functions";

class KitPlanMovilidadPlanMovilidad extends React.PureComponent {
  render() {
    return (
      <div>
          <div className="row">
            <div className="col-sm-9 text-left">
              <div className="PM-cuadro-3">
                <h5><strong>Descarga el kit de difusión con material digital.</strong></h5>
              </div>
            </div>
            <div className="col-sm-3 btn-material">
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                onClick={() => {
                  window.open(KIT,'_blank');
                  dataLayerTag({
                    'event': 'etapa_3_descarga_kit ',
                    'etapa': '3'
                  });
                }}
              >Descargar kit</button>
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  estadoProceso: state.planMovilidad.estadoProceso,
  isLoadingDocumento: state.planMovilidad.isLoadingDocumento,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(KitPlanMovilidadPlanMovilidad);
